"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giovanni-valdarno": {
    "a30295a4": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "badiola": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "feae742a": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "bani": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3763cc87": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "campagna": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b76817aa": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e56636a7": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "cetinale": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c8dcf041": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "coop": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "27b4aeda": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "fornaci": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0e961eb1": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "gruccia": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1006fde1": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "oltrarno": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a3c21c82": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-alle-forche": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "487a5cec": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "pruneto-montecarlo": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4d2dae83": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "restone": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2803ab65": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "stadio": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8d8c874f": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "vacchereccia": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c7ed1731": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "ville": [{
      "hkey": "066b0cdd",
      "slug": "san-giovanni-valdarno",
      "name": "San Giovanni Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;